<template>
  <div class="offer-wrapper pull-left">
    <div class="search-wrapper">
      <div class="search-description">{{'search' | translate}}</div>
      <div class="search-input-wrapper">
        <label class="vertical-align-absolute"
                v-if="!searchInput.length"
               for="search-input">{{'searchValue' | translate}}</label>
        <input type="text"
               name="search-input"
               id="search-input"
               ref="searchInput"
               @keydown="$event.stopPropagation()"
               v-model="searchInput">
      </div>
      <div class="search-close-wrapper"
           @click="goHome">
        <i class="n-i n-i-close"></i>
      </div>
    </div>
    <div class="offer-route-view-wrapper">
      <router-view name="offer" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import gateway from '../services/gateway';

export default {
  name: 'OfferBox',
  computed: {
    ...mapGetters([
      'selected',
      'searchedValue',
      'searchInputActive',
    ]),
    searchInput: {
      set(value) {
        this.setSearchedValue(value);
      },
      get() {
        return this.searchedValue;
      },
    },
  },
  created() {
    if (Object.keys(this.selected.match).length) {
      this.$router.push({ name: 'betOffer' });
    } else {
      this.$router.push({ name: 'fullOffer' });
    }
  },
  methods: {
    ...mapActions([
      'setSearchedValue',
    ]),
    /**
     * Close full offer view
     */
    goHome() {
      gateway.sendMessage('Widget.UpdateSettings', {
        gamesHelp: {
          show: true,
        },
        calculator: {
          show: true,
        },
        ticketSession: {
          show: true,
        },
        ticketList: {
          show: true,
        },
      });
      this.$store.commit('CLEAR_SELECTED');
      this.$router.push({ path: 'betting' });
    },
  },
  watch: {
    searchInputActive: {
      handler() {
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, 100);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .offer-wrapper {
    background-color: #ffffff;
    color: #455a64;
    height: calc(100% - 35px);
    width: 70.8333333333%;
    .search-wrapper {
      border-bottom: 1px solid #e8e9ea;
      font-size: 0.875rem;
      padding: 10px;
      .search-description {
        display: inline-block;
        text-align: center;
        text-transform: capitalize;
        width: 10%;
        &:after {
          content: ':';
          padding-left: 5px;
        }
      }
      .search-input-wrapper {
        display: inline-block;
        position: relative;
        width: 85%;
        label {
          padding-left: 10px;
        }
        input {
          border: 1px solid #cfd8dc;
          font-size: 0.875rem;
          padding: 5px;
          width: 100%;
          &:focus {
            outline: 5px auto #1b6094;
          }
        }
      }
      .search-close-wrapper {
        display: inline-block;
        text-align: center;
        width: 4%;
        i {
          font-size: 1.0625rem;
        }
      }
    }
    .offer-route-view-wrapper {
      font-size: 12px;
      height: calc(100% - 35px);
      max-height: 90%;
      overflow-y: auto;
    }
  }
</style>
